import React, { memo, useCallback } from 'react'

import { useUnit } from 'effector-react'

import { Typo } from 'components/_old/Typo'

import { Typography } from 'components/atoms/Typography'
import { Validate } from 'components/atoms/Validate'

import { CheckboxWithLabel } from 'components/molecules/WithLabel/WithLabel.jsx'

import { $form, $validation, setField } from '../index'

const AgreedCheckbox = memo((): React.ReactElement => {
  const [form, validation] = useUnit([$form, $validation])

  const handleChange = useCallback((value: boolean) => {
    setField({
      field: 'agreed',
      value,
    })
  }, [])

  return (
    <Validate rules={validation.agreed.rules}>
      <CheckboxWithLabel
        label={
          <Typography size={14}>
            <Typo>I understand and agree with the terms provided in both the disclaimer and declaration</Typo>
          </Typography>
        }
        size="smaller"
        checked={form.agreed ?? false}
        onChange={handleChange}
        required
        value={form.agreed ?? false}
        outline
        data-test-id="agreed-checkbox"
      />
    </Validate>
  )
})
AgreedCheckbox.displayName = 'AgreedCheckbox'

export { AgreedCheckbox }
